module.exports = __webpack_public_path__ + "static/img/10.456e2f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/sp/10.png
// module id = F/ZX
// module chunks = 0